// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","Badge":"GEV_ya","fadeInFrames":"_2iNqGJ"};